import {
  CASE_FETCH_HEARINGROOM_LOGS_BEGIN,
  CASE_FETCH_HEARINGROOM_LOGS_SUCCESS,
  CASE_FETCH_HEARINGROOM_LOGS_FAILURE,
  CASE_FETCH_HEARINGROOM_LOGS_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const fetchHearingRoomLogs = createPromiseAction(CASE_FETCH_HEARINGROOM_LOGS_BEGIN);

export function dismissFetchHearingRoomLogsFeedback() {
  return {
    type: CASE_FETCH_HEARINGROOM_LOGS_DISMISS_FEEDBACK,
  };
}

export function* doFetchHearingRoomLogs(action) {
  const { caseId, roomType } = action.payload;

  let res = yield call(api.get, `/cases/${caseId}/room-type/${roomType}/logs`);

  if (res && res.error) {
    yield put({
      type: CASE_FETCH_HEARINGROOM_LOGS_FAILURE,
      feedback: {
        message: 'feedback.fetchHearingRoomLogsFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_FETCH_HEARINGROOM_LOGS_SUCCESS,
    data: { hearingRoomLogs: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchFetchHearingRoomLogs() {
  yield takeLatest(fetchHearingRoomLogs, withCurrentCaseId(doFetchHearingRoomLogs));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_FETCH_HEARINGROOM_LOGS_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        fetchHearingRoomLogsPending: true,
        fetchHearingRoomLogsFeedback: null,
      };

    case CASE_FETCH_HEARINGROOM_LOGS_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchHearingRoomLogsPending: false,
        fetchHearingRoomLogsFeedback: action.feedback,
      };

    case CASE_FETCH_HEARINGROOM_LOGS_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchHearingRoomLogsPending: false,
        fetchHearingRoomLogsFeedback: action.feedback,
      };

    case CASE_FETCH_HEARINGROOM_LOGS_DISMISS_FEEDBACK:
      // Dismiss the request failure Feedback
      return {
        ...state,
        fetchHearingRoomLogsFeedback: null,
      };

    default:
      return state;
  }
}
